import { Component, OnInit, Input } from '@angular/core';
import {GlobalServices} from '../global.services';

@Component({
  selector: 'app-why-book-with-us',
  templateUrl: './why-book-with-us.component.html',
  styleUrls: ['./why-book-with-us.component.scss']
})
export class WhyBookWithUsComponent implements OnInit {
  @Input() child:string;
  constructor(private globalService: GlobalServices) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    if (this.globalService.isBrowser) {
      setTimeout(() => {
        if (this.globalService.isBrowser) {
          this.globalService.scrollbar();
        }
      }, 1000);
    }
  }

}
